import { aiColors } from '@euler/app/flows/ai-suite/theme';
import { FeatureNotEnabledView } from '@euler/components/entitlements/FeatureNotEnabledView';
import { useStoreFeature } from '@euler/functions/entitlements/useStoreFeature';
import { useUserProfileInfo } from '@euler/functions/user/useUserProfileInfo';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { StoreFeature } from '@euler/model/enum';
import { StackActions, useNavigation } from '@react-navigation/native';
import { useEffect } from 'react';
import { ActivityIndicator, Platform, Text, View } from 'react-native';
import { BiPageHeader } from './components/ui/BiPageHeader';
import { BiRetry } from './components/ui/BiRetry';
import { useBiEntry } from './functions/useBiEntry';

/**
 * The BI entry: swaps itself for the caller's default dashboard, or for
 * the dashboard list (its empty state) when they can see none. Replacing
 * keeps it out of the history, so back from either lands where BI was
 * entered from; on a phone or iPad it replaces without the transition,
 * which would otherwise flash this page by. The server creates the
 * caller's default set on their first visit before answering.
 */
function BiHome() {
  const navigation = useNavigation();
  const { state, retry } = useBiEntry();
  useEffect(() => {
    if (state.kind !== 'ready') return;
    // The web stack does not animate a replace, and a param there would
    // show in the URL.
    const instant = Platform.OS === 'web' ? {} : { instant: true };
    navigation.dispatch(
      state.dashboardId
        ? StackActions.replace('BiDashboard', {
            dashboardId: state.dashboardId,
            ...instant,
          })
        : StackActions.replace('BiDashboards', instant),
    );
  }, [navigation, state]);
  return (
    <View style={{ flex: 1, backgroundColor: aiColors.background }}>
      <BiPageHeader title="数据看板" onBack={() => navigation.goBack()} />
      <View style={{ flex: 1, alignItems: 'center', justifyContent: 'center' }}>
        {state.kind === 'failed' ? (
          <BiRetry onRetry={retry} />
        ) : (
          <ActivityIndicator color={aiColors.primary} />
        )}
      </View>
    </View>
  );
}

export const BiHomePage = wrapNavigatorScreen(
  () => {
    const profile = useUserProfileInfo();
    const bi = useStoreFeature(StoreFeature.Bi);
    if (!bi.enabled) return <FeatureNotEnabledView feature={StoreFeature.Bi} />;
    if (!profile?.user.enabled)
      return <Text>当前门店尚未开通经营分析，或账号不可用。</Text>;
    return <BiHome key={`${profile.org.id}:${profile.store.id}`} />;
  },
  { title: '数据看板', headerShown: false, headerMode: 'float' },
);
